import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../../core/i18n';
import { UrlModule } from '../../../../../core/routing';
import { HeaderNavigationItemModule } from '../../../components/header-navigation-item';

@Component({
  selector: 'py-menu-cart-anonymous',
  templateUrl: './menu-cart-anonymous.component.html',
  styleUrls: ['./menu-cart-anonymous.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, I18nModule, NzIconModule, HeaderNavigationItemModule, UrlModule],
})
export class MenuCartAnonymousComponent {
  constructor() {}
}
